/**
 * Avviso di nuova versione disponibile.
 *
 * Una scheda già aperta continua a eseguire il JavaScript caricato all'apertura:
 * dopo un rilascio si lavora sulla versione vecchia senza accorgersene. Qui si
 * confronta l'identificativo di build compilato nel bundle con quello pubblicato
 * dal server, e si propone di ricaricare.
 *
 * Non ricarica mai da solo: un refresh a sorpresa mentre si sta compilando un
 * consuntivo farebbe perdere quello che si sta scrivendo.
 */
import { useEffect, useState } from 'react';

const MIO = import.meta.env.VITE_BUILD_ID || null;
const OGNI = 5 * 60 * 1000;   // 5 minuti

export default function AvvisoVersione() {
  const [nuova, setNuova] = useState(null);
  const [ignorata, setIgnorata] = useState(null);

  useEffect(() => {
    // In sviluppo non c'è un identificativo di build: il controllo non serve.
    if (!MIO) return;
    let vivo = true;

    const controlla = async () => {
      try {
        // no-store più parametro variabile: il file è piccolo ma deve essere
        // riletto davvero, altrimenti si confronta la versione con sé stessa.
        const r = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) return;
        const { build } = await r.json();
        if (vivo && build && build !== MIO) setNuova(build);
      } catch { /* offline o server in riavvio: si riprova al giro dopo */ }
    };

    controlla();
    const t = setInterval(controlla, OGNI);
    // Tornando sulla scheda dopo una pausa è il momento più utile per saperlo.
    // Si ascoltano entrambi gli eventi e senza pretendere visibilityState
    // 'visible': in alcuni contesti resta 'hidden' anche a scheda in primo
    // piano, e il controllo non scatterebbe mai.
    const alFuoco = () => { if (!document.hidden) controlla(); };
    document.addEventListener('visibilitychange', alFuoco);
    window.addEventListener('focus', controlla);
    return () => {
      vivo = false;
      clearInterval(t);
      document.removeEventListener('visibilitychange', alFuoco);
      window.removeEventListener('focus', controlla);
    };
  }, []);

  if (!nuova || nuova === ignorata) return null;

  return (
    <div className="bg-brand-600 text-white px-4 py-2 flex items-center gap-3 text-sm shrink-0">
      <span className="flex-1">
        <strong>Nuova versione disponibile.</strong>{' '}
        <span className="text-brand-100">
          Stai usando quella caricata all'apertura della pagina: ricarica per avere le ultime modifiche.
        </span>
      </span>
      <button className="bg-white text-brand-700 font-medium px-3 py-1 rounded hover:bg-brand-50"
              onClick={() => window.location.reload()}>
        Ricarica
      </button>
      <button className="text-brand-100 hover:text-white px-1" title="Più tardi"
              onClick={() => setIgnorata(nuova)}>
        ✕
      </button>
    </div>
  );
}
